import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import Schedules from './Schedules';
import SchedulePlanner from './SchedulePlanner';

const NoMatch = () => { return (<div>No such page</div> ); };

class Router extends Component {
    render() {
        const { match } = this.props;
        const matchUrl = match.url;

        return (
            <Switch>
                <Route exact path={ matchUrl } component={ Schedules } />

                <Route exact path={ `${ matchUrl }/schedules` } component={ Schedules } />

                <Route exact path={ `${ matchUrl }/schedules/:sid` } component={ SchedulePlanner } />


                <Route component={ NoMatch } />
            </Switch>
        );
    }
}

export default withRouter( Router );
